// Simulate fetching add-ons for the campaign
export const fetchAddOns = () =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        { id: 1, name: 'Penjemputan ambulance', info: 'Layanan ambulance gratis untuk pasien.' },
      ]);
    }, 500);
  });

// Simulate submitting campaign type
export const submitCampaignType = (type) => {
  // For prototype, just log the selection
  console.log('Selected campaign type:', type);
};
